import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { useUnit } from 'effector-react';
import { NotificationsPortalContext } from '@nx-frontend/shared/types';
import {
  NotificationPanelFilterWorkspace,
  NotificationPanelFilterWorkspaceIcon,
} from './notification-panel-filter-workspace-icon';
import { $notificationPanelFilter } from './store';

interface NotificationPanelFilterSelectedPlaceProps {
  portalContext: NotificationsPortalContext;
  workspace?: NotificationPanelFilterWorkspace;
}

interface PlaceCrumbsProps {
  workspace?: NotificationPanelFilterWorkspace;
  title: string;
}

const PlaceCrumb = (props: PlaceCrumbsProps) => {
  const { workspace, title } = props;
  return (
    <>
      {workspace ? <NotificationPanelFilterWorkspaceIcon workspace={workspace} size="sm" /> : null}
      <span className="text-neutral-400 mx-0.5">•</span>
      <span className="text-nowrap">{title}</span>
    </>
  );
};

export const NotificationPanelFilterSelectedPlace = (props: NotificationPanelFilterSelectedPlaceProps) => {
  const { portalContext, workspace } = props;

  const [notificationPanelFilter] = useUnit([$notificationPanelFilter]);
  const { workspaceId, portalId } = notificationPanelFilter;
  const t = useTranslations('notification_panel');

  const place = useMemo(() => {
    const portalName = portalContext?.settings?.name ?? t('notification_panel-client_portal');
    if (workspaceId && !portalId)
      return <PlaceCrumb workspace={workspace} title={t('notification_panel-internal_space')} />;
    if (portalId && !workspaceId)
      return (
        <PlaceCrumb
          workspace={workspace}
          title={portalName.length > 10 ? `${portalName.slice(0, 10)}...` : portalName}
        />
      );
    if (workspaceId && portalId) return <span className="text-xs">2 places</span>;

    return null;
  }, [workspaceId, portalId, portalContext, workspace, t]);

  if (!workspaceId && !portalId) return null;

  return <div className="flex items-center text-[10px] leading-3 font-semibold">{place}</div>;
};
